import { Anchor, Text } from '@zillow/constellation-10';
import type { ComponentType } from 'react';

import type { PartialMessageProps } from '../../model/PartialMessage';

type Props = {
  partialMessages: Array<PartialMessageProps>;
  fontType?: 'body' | 'body-sm' | 'body-xs';
  linkComponent?: ComponentType<React.ComponentProps<typeof Anchor>>;
  onUrlClick?: (e: React.MouseEvent<HTMLAnchorElement>, url: string, text: string) => void;
  eventId?: string;
};

export const PartialMessage = ({
  partialMessages = [],
  fontType = 'body',
  linkComponent: LinkComponent = Anchor,
  onUrlClick,
  eventId,
}: Props) => {
  return (
    <div data-testid="PartialMessage">
      {partialMessages.map(({ url, text, isBold }, i) => (
        <Text
          key={`partial-message-${text}`}
          textStyle={isBold ? `${fontType}-bold` : fontType}
          css={{ color: 'currentColor' }}
        >
          {url ? (
            <LinkComponent
              key={i}
              href={url}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => onUrlClick?.(e, url, text)}
              target="_blank"
              data-eventid={eventId}
            >
              {`${text}`}
            </LinkComponent>
          ) : (
            `${text}`
          )}
        </Text>
      ))}
    </div>
  );
};
